import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import AppWrapper from './AppWrapper';

ReactDOM.render(<AppWrapper />, document.getElementById('root'));
